export const ClientActionTypes = {


    VENDOR_DATA_FIRST: '@@auth/VENDOR_DATA_FIRST',
    VENDOR_DATA_LOADING: '@@auth/VENDOR_DATA_LOADING',
    VENDOR_DATA_SUCCESS: '@@auth/VENDOR_DATA_SUCCESS',
    VENDOR_DATA_ERROR: '@@auth/VENDOR_DATA_ERROR',

    CREATE_VENDOR_DATA_FIRST: '@@auth/CREATE_VENDOR_DATA_FIRST',
    CREATE_VENDOR_DATA_LOADING: '@@auth/CREATE_VENDOR_DATA_LOADING',
    CREATE_VENDOR_DATA_SUCCESS: '@@auth/CREATE_VENDOR_DATA_SUCCESS',
    CREATE_VENDOR_DATA_ERROR: '@@auth/CREATE_VENDOR_DATA_ERROR',

    UPDATE_VENDOR_DATA_FIRST: '@@auth/UPDATE_VENDOR_DATA_FIRST',
    UPDATE_VENDOR_DATA_LOADING: '@@auth/UPDATE_VENDOR_DATA_LOADING',
    UPDATE_VENDOR_DATA_SUCCESS: '@@auth/UPDATE_VENDOR_DATA_SUCCESS',
    UPDATE_VENDOR_DATA_RESET: '@@auth/UPDATE_VENDOR_DATA_RESET',
    UPDATE_VENDOR_DATA_ERROR: '@@auth/UPDATE_VENDOR_DATA_ERROR',

    DELETE_VENDOR_DATA_FIRST: '@@auth/DELETE_VENDOR_DATA_FIRST',
    DELETE_VENDOR_DATA_LOADING: '@@auth/DELETE_VENDOR_DATA_LOADING',
    DELETE_VENDOR_DATA_SUCCESS: '@@auth/DELETE_VENDOR_DATA_SUCCESS',
    DELETE_VENDOR_DATA_RESET: '@@auth/DELETE_VENDOR_DATA_RESET',
    DELETE_VENDOR_DATA_ERROR: '@@auth/DELETE_VENDOR_DATA_ERROR',

    ACCOUNT_DATA_FIRST: '@@auth/ACCOUNT_DATA_FIRST',
    ACCOUNT_DATA_LOADING: '@@auth/ACCOUNT_DATA_LOADING',
    ACCOUNT_DATA_SUCCESS: '@@auth/ACCOUNT_DATA_SUCCESS',
    ACCOUNT_DATA_ERROR: '@@auth/ACCOUNT_DATA_ERROR',

    CREATE_ACCOUNT_DATA_FIRST: '@@auth/CREATE_ACCOUNT_DATA_FIRST',
    CREATE_ACCOUNT_DATA_LOADING: '@@auth/CREATE_ACCOUNT_DATA_LOADING',
    CREATE_ACCOUNT_DATA_SUCCESS: '@@auth/CREATE_ACCOUNT_DATA_SUCCESS',
    CREATE_ACCOUNT_DATA_ERROR: '@@auth/CREATE_ACCOUNT_DATA_ERROR',

    UPDATE_ACCOUNT_DATA_FIRST: '@@auth/UPDATE_ACCOUNT_DATA_FIRST',
    UPDATE_ACCOUNT_DATA_LOADING: '@@auth/UPDATE_ACCOUNT_DATA_LOADING',
    UPDATE_ACCOUNT_DATA_SUCCESS: '@@auth/UPDATE_ACCOUNT_DATA_SUCCESS',
    UPDATE_ACCOUNT_DATA_RESET: '@@auth/UPDATE_ACCOUNT_DATA_RESET',
    UPDATE_ACCOUNT_DATA_ERROR: '@@auth/UPDATE_ACCOUNT_DATA_ERROR',

    DELETE_ACCOUNT_DATA_FIRST: '@@auth/DELETE_ACCOUNT_DATA_FIRST',
    DELETE_ACCOUNT_DATA_LOADING: '@@auth/DELETE_ACCOUNT_DATA_LOADING',
    DELETE_ACCOUNT_DATA_SUCCESS: '@@auth/DELETE_ACCOUNT_DATA_SUCCESS',
    DELETE_ACCOUNT_DATA_RESET: '@@auth/DELETE_ACCOUNT_DATA_RESET',
    DELETE_ACCOUNT_DATA_ERROR: '@@auth/DELETE_ACCOUNT_DATA_ERROR',

    UPLOAD_ACCOUNT_DATA_FIRST: '@@auth/UPLOAD_ACCOUNT_DATA_FIRST',
    UPLOAD_ACCOUNT_DATA_LOADING: '@@auth/UPLOAD_ACCOUNT_DATA_LOADING',
    UPLOAD_ACCOUNT_DATA_SUCCESS: '@@auth/UPLOAD_ACCOUNT_DATA_SUCCESS',
    UPLOAD_ACCOUNT_DATA_RESET: '@@auth/UPLOAD_ACCOUNT_DATA_RESET',
    UPLOAD_ACCOUNT_DATA_ERROR: '@@auth/UPLOAD_ACCOUNT_DATA_ERROR',

    UPLOAD_CLIENT_DATA_FIRST: '@@auth/UPLOAD_CLIENT_DATA_FIRST',
    UPLOAD_CLIENT_DATA_LOADING: '@@auth/UPLOAD_CLIENT_DATA_LOADING',
    UPLOAD_CLIENT_DATA_SUCCESS: '@@auth/UPLOAD_CLIENT_DATA_SUCCESS',
    UPLOAD_CLIENT_DATA_RESET: '@@auth/UPLOAD_CLIENT_DATA_RESET',
    UPLOAD_CLIENT_DATA_ERROR: '@@auth/UPLOAD_CLIENT_DATA_ERROR',

    STATE_EMPTY_FIRST: '@@auth/STATE_EMPTY_FIRST'
};
